import { validateFormInput } from 'common/helpers/addresses';
import {
  isDayMonthYearADate,
  validateMinimumAge,
  isValidBirthDate
} from 'common/helpers/dateHelper';
// import { getTenantId } from 'common/helpers/apiHelper';
import { getMinimumAge } from 'common/helpers/miscHelper';
import { isValidPhoneNumber } from 'common/helpers/phoneHelper';

export const addressProperties = {
  firstName: { type: 'string' },
  lastName: { type: 'string' },
  birthDay: { type: 'integer' },
  birthMonth: { type: 'integer' },
  birthYear: { type: 'integer' },
  company: { type: 'string' },
  phone: { type: 'string' },
  address: { type: 'string' },
  address2: { type: 'string' },
  city: { type: 'string' },
  stateCode: { type: 'string' },
  zipCode: {
    type: 'string',
    pattern: '[A-Z0-9]',
    minLength: 3,
    maxLength: 10
  },
  countryCode: { type: 'string', maxLength: 2, minLength: 2 }
};

export const addressRequired = [
  'firstName',
  'lastName',
  'birthDay',
  'birthMonth',
  'birthYear',
  'phone',
  'address',
  'city',
  'zipCode',
  'countryCode'
];

// type could be shipping, billing, or addressBook
export const customValidate = (address, type, settings) => {
  const errorArray = validateFormInput(address);

  if (address.birthDay && (address.birthDay < 1 || address.birthDay > 31)) {
    const error = { field: 'birthDay', message: 'Invalid Day' };
    errorArray.push(error);
  }
  if (
    address.birthMonth &&
    (address.birthMonth < 1 || address.birthMonth > 12)
  ) {
    const error = { field: 'birthMonth', message: 'Invalid Month' };
    errorArray.push(error);
  }
  if (
    address.birthYear &&
    (address.birthYear < 1900 || address.birthYear > 2020)
  ) {
    const error = { field: 'birthYear', message: 'Invalid Year' };
    errorArray.push(error);
  }
  if (address.birthDay && address.birthMonth && address.birthYear) {
    if (
      !isDayMonthYearADate(
        address.birthDay,
        address.birthMonth,
        address.birthYear
      )
    ) {
      const error = { field: 'birthDay', message: 'Invalid Day' };
      errorArray.push(error);
    }

    const isMinimumAge = validateMinimumAge(
      address.birthDay,
      address.birthMonth,
      address.birthYear,
      settings
    );

    if (!isMinimumAge) {
      const minAge = getMinimumAge(settings);
      const error = {
        field: 'birthYear',
        message: `Must be at least ${minAge} years old`
      };
      errorArray.push(error);
    }

    if (!isValidBirthDate(address.birthDay, address.month, address.birthYear)) {
      const error = {
        field: 'birthYear',
        message: `Invalid birth date`
      };
      errorArray.push(error);
    }
  }

  if (
    address.phone &&
    !isValidPhoneNumber(address.phone, address.countryCode, settings)
  ) {
    errorArray.push({
      field: 'phone',
      message: 'Invalid phone number for your country code'
    });
  }

  // const tlErrors = validateForTorontoLife(address, type);

  const newErrors = [...errorArray];

  return newErrors;
};

// This function is utter shit - and we need to dump it
// const validateForTorontoLife = (address, type) => {
//   const errorArray = [];
//   if (getTenantId() !== 'torontolife-wine') {
//     return errorArray;
//   }
//   if (type === 'billing') {
//     return errorArray;
//   }
//   if (
//     address.zipCode &&
//     !validZipCodes().includes(address.zipCode.substring(0, 3).toUpperCase())
//   ) {
//     errorArray.push({
//       field: 'zipCode',
//       message: 'Unfortunately we can not ship to your postal code at this time'
//     });
//   }
//   return errorArray;
// };

// const validZipCodes = () => {
//   const zipCodes = [
//     'L1P',
//     'L0C',
//     'L0H',
//     'L0J',
//     'L0P',
//     'L0R',
//     'L1R',
//     'L1S',
//     'L1T',
//     'L1V',
//     'L3M',
//     'L3P',
//     'L3S',
//     'L3T',
//     'L4B',
//     'L4C',
//     'L4E',
//     'L4H',
//     'L4J',
//     'L4K',
//     'L4L',
//     'L4S',
//     'L4T',
//     'L5C',
//     'L5M',
//     'L5N',
//     'L6A',
//     'L6B',
//     'L6C',
//     'L6E',
//     'L6G',
//     'L6L',
//     'L6M',
//     'L7K',
//     'L7L',
//     'L7P',
//     'L7R',
//     'L7T',
//     'L8B',
//     'L8E',
//     'L8S',
//     'L9C',
//     'L9H',
//     'L9N',
//     'LOP',
//     'M1B',
//     'M1C',
//     'M1E',
//     'M1G',
//     'M1H',
//     'M1J',
//     'M1K',
//     'M1L',
//     'M1M',
//     'M1N',
//     'M1P',
//     'M1R',
//     'M1S',
//     'M1T',
//     'M1V',
//     'M1W',
//     'M1X',
//     'M2H',
//     'M2J',
//     'M2L',
//     'M2M',
//     'M2N',
//     'M2P',
//     'M2R',
//     'M3A',
//     'M3B',
//     'M3C',
//     'M3H',
//     'M3J',
//     'M3K',
//     'M3M',
//     'M3N',
//     'M4A',
//     'M4B',
//     'M4C',
//     'M4E',
//     'M4G',
//     'M4H',
//     'M4J',
//     'M4K',
//     'M4L',
//     'M4M',
//     'M4N',
//     'M4P',
//     'M4R',
//     'M4S',
//     'M4T',
//     'M4V',
//     'M4W',
//     'M4X',
//     'M4Y',
//     'M5A',
//     'M5B',
//     'M5C',
//     'M5E',
//     'M5G',
//     'M5H',
//     'M5J',
//     'M5K',
//     'M5L',
//     'M5M',
//     'M5N',
//     'M5P',
//     'M5R',
//     'M5S',
//     'M5T',
//     'M5V',
//     'M5W',
//     'M5X',
//     'M6A',
//     'M6B',
//     'M6C',
//     'M6E',
//     'M6G',
//     'M6H',
//     'M6J',
//     'M6K',
//     'M6L',
//     'M6M',
//     'M6N',
//     'M6P',
//     'M6R',
//     'M6S',
//     'M7A',
//     'M7R',
//     'M7Y',
//     'M8V',
//     'M8W',
//     'M8X',
//     'M8Y',
//     'M8Z',
//     'M9A',
//     'M9B',
//     'M9C',
//     'M9L',
//     'M9M',
//     'M9N',
//     'M9P',
//     'M9R',
//     'M9V',
//     'M9W'
//   ];
//   return zipCodes;
// };
